import {
  RootDiv,
  TitleTypography,
  DivisionLine,
  InfoContainerDiv,
  InfoContainerItem,
  InfoContainerItemImg,
  InfoContainerItemText,
} from '../styles/Info.styles';

export function Info() {
  return (
    <RootDiv>
      <TitleTypography>¿Qué haremos con tu receta?</TitleTypography>
      <DivisionLine />
      <InfoContainerDiv>
        <InfoContainerItem>
          <InfoContainerItemImg
            src="/assets/images/prescription1.png"
            alt="persona"
          />
          <InfoContainerItemText>
            Al terminar la compra tu receta será revisada por nuestros químicos
            farmacéuticos.
          </InfoContainerItemText>
        </InfoContainerItem>
        <InfoContainerItem>
          <InfoContainerItemImg
            src="/assets/images/prescription2.png"
            alt="receta"
          />
          <InfoContainerItemText>
            De ser necesario retiraremos el documento original al momento del
            despacho.
          </InfoContainerItemText>
        </InfoContainerItem>
        <InfoContainerItem>
          <InfoContainerItemImg
            src="/assets/images/prescription3.png"
            alt="cashback"
          />
          <InfoContainerItemText>
            En caso de que la receta sea rechazada, te contactaremos para el
            reembolso del producto.
          </InfoContainerItemText>
        </InfoContainerItem>
      </InfoContainerDiv>
    </RootDiv>
  );
}
